export default __webpack_public_path__ + "static/media/education-topic-hover.5254ba19.svg";